import { FC } from "react";
import { Box, Typography } from "@material-ui/core";

import { NON_FAILED_DEAL_STATE_TO_DISPLAY_NAME } from "services/offers/constants";
import theme from "theme";

import NextStepBox, { NextStepStatus } from "../NextStepBox";

interface ProcessStepsProps {
  dueDiligenceStep: NextStepStatus;
  paymentStep: NextStepStatus;
  transferStep: NextStepStatus;
  transactionCompleteStep: NextStepStatus;
}

const DealProcessSteps: FC<ProcessStepsProps> = ({
  dueDiligenceStep,
  paymentStep,
  transferStep,
  transactionCompleteStep,
}) => {
  return (
    <>
      <NextStepBox
        title={NON_FAILED_DEAL_STATE_TO_DISPLAY_NAME.awaiting_due_diligence}
        description={
          <Box>
            <Typography
              style={{ fontSize: "1.125rem", marginBottom: theme.spacing(2) }}
            >
              A Royalty Exchange representative will contact you regarding the
              closing documentation needed to finalize this deal.
            </Typography>
            <Typography style={{ fontSize: "1.125rem" }}>
              We&apos;ll conduct the necessary due diligence to ensure a clear
              path to ownership and payment. This should take no more than three
              days. If necessary, we will call you to resolve any
              irregularities.
            </Typography>
          </Box>
        }
        status={dueDiligenceStep}
      />
      <NextStepBox
        title={NON_FAILED_DEAL_STATE_TO_DISPLAY_NAME.awaiting_payment}
        description={
          <Box>
            <Typography style={{ fontSize: "1.125rem" }}>
              We are awaiting payment from the buyer.
            </Typography>
          </Box>
        }
        status={paymentStep}
      />
      <NextStepBox
        title={NON_FAILED_DEAL_STATE_TO_DISPLAY_NAME.awaiting_transfer}
        description={
          <Box>
            <Typography
              style={{
                fontSize: "1.125rem",
                marginBottom: theme.spacing(1),
              }}
            >
              The buyer&apos;s payment has been received and paperwork has been
              submitted to the royalty payor.
            </Typography>

            <Typography style={{ fontSize: "1.125rem" }}>
              We are awaiting confirmation from the royalty payor that the
              transfer has been processed.
            </Typography>
          </Box>
        }
        status={transferStep}
      />
      <NextStepBox
        title={NON_FAILED_DEAL_STATE_TO_DISPLAY_NAME.filled}
        description={
          <Box>
            <Typography style={{ fontSize: "1.125rem" }}>
              Once your royalty payor confirms the royalties are transferred to
              the buyer, we&apos;ll send you the sale proceeds and the
              transaction is complete.
            </Typography>
          </Box>
        }
        status={transactionCompleteStep}
      />
    </>
  );
};

export default DealProcessSteps;
